module.exports = __webpack_public_path__ + "media/images/badges/rowhouse/500k-inactive-2083a5f6f957c433a71b87c34ec5969a.png";